export default __webpack_public_path__ + "static/media/logo_streetparking.6e6fc997.svg";